<section class="playground">
  <h2 class="playground__heading">Info chip</h2>
  <p class="playground__hint">
    Componente <code>Info_chip</code> del
    <a
      href="https://www.figma.com/design/nZEfdJ8pN0ILY9cAkO3DSG/Munily-UI-Kit-%7C-Design-system?node-id=9262-17879"
      target="_blank"
      rel="noopener noreferrer"
      >Munily UI Kit</a
    >
    (<code>size</code> small / large; <code>type</code> filled / outline; <code>shape</code> pill vs 8px). Selector: <code>app-info-chip</code>. Ver <code>UI_INVENTORY.md</code>.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>
      <label class="playground__field">
        <span>color</span>
        <select [(ngModel)]="color">
          <option *ngFor="let c of colors" [value]="c">{{ c }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>type</span>
        <select [(ngModel)]="type">
          <option *ngFor="let t of types" [value]="t">{{ t }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let z of sizes" [value]="z">{{ z }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>shape</span>
        <select [(ngModel)]="shape">
          <option *ngFor="let s of shapes" [value]="s">{{ s }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>iconSet</span>
        <select [(ngModel)]="iconSet">
          <option *ngFor="let i of iconSets" [value]="i">{{ i }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>iconLeading (solo type filled)</span>
        <input type="text" [(ngModel)]="iconLeading" placeholder="ej: schedule" />
      </label>
      <label class="playground__field">
        <span>iconTrailing (ligature)</span>
        <input type="text" [(ngModel)]="iconTrailing" placeholder="solo si no removable" />
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="removable" />
        <span>removable</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <app-info-chip
          [label]="label"
          [color]="color"
          [type]="type"
          [size]="size"
          [shape]="shape"
          [iconSet]="iconSet"
          [iconLeading]="iconLeading || undefined"
          [iconTrailing]="iconTrailing || undefined"
          [removable]="removable"
          (onRemove)="onRemove()"
        ></app-info-chip>
      </div>
      <p *ngIf="removable" class="playground__meta">onRemove emitido: {{ removeCount }} veces</p>
    </div>
  </div>
</section>
